import { render, staticRenderFns } from "./DopplerWaveShiftViz.vue?vue&type=template&id=178fe3e7&scoped=true"
import script from "./DopplerWaveShiftViz.vue?vue&type=script&lang=js"
export * from "./DopplerWaveShiftViz.vue?vue&type=script&lang=js"
import style0 from "./DopplerWaveShiftViz.vue?vue&type=style&index=0&id=178fe3e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fe3e7",
  null
  
)

export default component.exports